import { TmElement } from '@thiememeulenhoff/lit-sdk';
import { css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { tagName } from '../../../helpers';
import {
  buttonHoverStyles,
  buttonStyles,
  hostStyles,
  readSpeakerStyles,
  readSpeakerAsButtonStyles,
} from '../read-speaker.shared.styles';

const tag = tagName('read-speaker-doc');

@customElement(tag)
export class ReadSpeakerDocComponent extends TmElement {
  @property()
  url = '';

  @property()
  streamLanguage = 'nl_NL';

  get encodedUrl() {
    const isEncoded = this.url !== decodeURIComponent(this.url);

    return isEncoded ? this.url : encodeURIComponent(this.url);
  }

  static override styles = css`
    :host {
      ${hostStyles};
    }

    :where(.read-speaker) {
      ${readSpeakerStyles};
      ${readSpeakerAsButtonStyles};
    }

    :where(.button) {
      ${buttonStyles};

      text-decoration: none;
    }

    @media (hover: hover) {
      :where(.button):hover {
        ${buttonHoverStyles};
      }
    }
  `;

  override render() {
    const streamLanguageElement = document.querySelector('[stream-language]');
    this.streamLanguage =
      streamLanguageElement?.getAttribute('stream-language') ||
      this.streamLanguage;

    return html`
      <div class="read-speaker">
        <a
          href="${`https://docreader.readspeaker.com/docreader/?jsmode=1&cid=brjei&lang=${this.streamLanguage}&url=${this.encodedUrl}`}"
          class="button"
          type="button"
          target="_blank"
          aria-label="Readspeaker document reader"
        >
          <a-icon name="voiceover"></a-icon>
        </a>
      </div>
    `;
  }
}
